import config from 'app-config'
import { reducers } from 'redux/core'
import { object } from 'common/helpers'
import { stringify, parse } from 'query-string'


const { go, goBack, goForward, push: _push, replace: _replace } = reducers.router

const push = (link, isForce, withRedirect) => {
  let url = link

  if (withRedirect) {
    url += `${/\?/.test(link) ? '&' : '?'}redirect=${encodeURIComponent(window.location.pathname)}${encodeURIComponent(window.location.search)}`
  }

  console.log('change route to:', url)

  if (isForce) {
    window.location.href = url
  }
  else {
    _push(url)
  }
}

const baseUrl = config.services.api.replace(/\/$/, '')

const replace = (link, isForce) => {
  if (isForce) {
    window.location.replace(`${baseUrl}${link}`)
  }
  else {
    _replace(link)
  }
}

/**
 * Add query to url
 * @param query {Object}
 * @param [shouldJoinStringValues] {Boolean} default "true"
 */
const addQuery = (query, shouldJoinStringValues = true) => {
  const parsedSearch = parse(window.location.search)
  const mergedSearch = shouldJoinStringValues
    ? object.joinStringValues(parsedSearch, query)
    : object.merge(parsedSearch, query)

  const search = stringify(mergedSearch)

  _push({
    pathname: window.location.pathname,
    search,
  })
}

/**
 * Remove query param
 * @param queryName {String}
 */
const removeQuery = (queryName) => {
  const parsedSearch = parse(window.location.search)

  delete parsedSearch[queryName]

  _push({
    pathname: window.location.pathname,
    search: stringify(parsedSearch),
  })
}

/**
 * Add or delete query param
 * @param query {Object}
 */
const toggleQuery = (query) => {
  const parsedSearch = parse(window.location.search)
  const mergedSearch = object.toggleValue(parsedSearch, query)

  const search = stringify(mergedSearch)

  _push({
    pathname: window.location.pathname,
    search,
  })
}


export default {
  go,
  goBack,
  goForward,
  push,
  replace,
  addQuery,
  removeQuery,
  toggleQuery,
}
